import { User } from 'types/user';

export const TEST_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxNSIsImV4dGVybmFsVXNlclR5cGVJZCI6IjgiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoidXNlckBnb3R0bGllYi5jb20iLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJ1c2VyQGdvdHRsaWViLmNvbSIsInRpbWVvdXQiOiI5MCIsInRpbWV3YXJuIjoiNSIsIndhcm4iOiIxMi82LzIyODYgMTE6NDI6MTUgQU0iLCJwaG9uZSI6IiIsIm1mYSI6IjEiLCJlbmNNYXgiOiI0MCIsInRyYW5zTWF4IjoiNDAiLCJleHAiOjk5OTk5OTk5OTksImlzcyI6Imh0dHBzOi8vaHJ6bi1kZXYtYXBpMDEuY29ycC52ZW50cmFoZWFsdGguY29tOjQwMSIsImF1ZCI6Imh0dHBzOi8vaHJ6bi1kZXYtYXBpMDEuY29ycC52ZW50cmFoZWFsdGguY29tOjQwMSJ9.Kc7x8-snpyfnetgynW9IcXz1bSuPUcUcrpEaSRPnja0';
export function getUserDummyData(): User {
  return {
    email: 'user@gottlieb.com',
    externalUserID: 15,
    facilities: [
      {
        clientID: 1,
        facilityID: 1,
        facilityName: 'St. Vincents Med. Ctr.'
      },
      {
        clientID: 1,
        facilityID: 239,
        facilityName: 'St Vincents Clay County'
      },
      {
        clientID: 1,
        facilityID: 343,
        facilityName: 'St Vincents Riverside'
      },
      {
        clientID: 1,
        facilityID: 1241,
        facilityName: 'Ascension St. Vincent St Johns'
      },
      {
        clientID: 1,
        facilityID: 10249,
        facilityName: 'Tristons Test facility'
      }
    ],
    token: TEST_TOKEN,
    externalUsersName: 'Armstrong, Triston',
    usesSingleSignOnDisallowsPortalPasswordReset: true,
    sessionTimeOutMinutes: 90,
    sessionTimeOutWarningMinutes: 5,
    isAdministrator: true,
    showMyTransactions: true,
    showMyAccount: true,
    showPatientStatement: true,
    showMyEncounters: true,
    requireMFA: false,
    phoneNumber: '',
    externalUserTypeID: 8,
    readOnly: false,
    encMaxFacilities: 40,
    transMaxFacilities: 40,
    isEmailMFA: false,
    codeDisplayMessage:
      'Please enter the code that has been sent to your mobile phone',
    resendTime: 15,
    showMyTransactionsX12DocumentLink: true,
    allowPreAuthorizationSearch: true,
    companyID: 1,
    companyName: 'Gottlieb'
  };
}
